<template>
  <div class="container">
    <div class="leftContainer">
      <img src="../images/loginBg.png" class="bgImage" alt="" />
      <img src="../images/loginLogo.svg" class="loginLogoImage" alt="" />
    </div>
    <div class="rightContainer">
      <form @submit="handleSubmit($event)">
        <h1>Witaj!</h1>
        <p>Login</p>

        <input
          required
          v-model="name"
          name="name"
          type="text"
          class="form-control p-4"
          id="Name"
        />

        <p>Hasło</p>

        <input
          required
          v-model="pass"
          name="pass"
          type="password"
          class="form-control p-4"
          id="Password"
        />

        <div class="alert alert-danger" role="alert" v-if="this.errorMessage">
          {{ this.errorMessage }}
        </div>
        <button type="submit" class="loginButton">Zaloguj się</button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "login",
  computed: {
    success() {
      return this.$store.getters.getLoginSuccess;
    },
    errorMessage() {
      return this.$store.getters.getLoginError;
    },
    token() {
      return this.$store.getters.getToken;
    },
  },
  created() {
    if (this.token !== null) {
      this.$router.push({ path: "../users" });
    }
  },
  data: function() {
    return {
      name: "",
      pass: "",
    };
  },

  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.$store.dispatch("login", {
        login: this.name,
        password: this.pass,
      });
    },
  },
};
</script>

<style scoped>
a {
  color: #090741;
}

a:hover {
  text-decoration: none;
  color: #090741;
}
.container {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 97vh;
  display: flex;
  flex-direction: row;
  max-width: 100%;
}
.leftContainer {
  position: relative;
  width: 45%;
  height: 97vh;
  margin: 0;
  padding: 0;
}
.rightContainer {
  margin: 0 !important;
  padding: 0 !important;
  position: relative;
  width: 55%;
  height: 97vh;
}
.bgImage {
  width: 100%;
  max-height: 98vh !important;
}
.loginLogoImage {
  width: 60%;
  height: 60% !important;
  max-height: 98vh !important;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.rightContainer form {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 396px;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  font-family: "Poppins", sans-serif;
  margin: 0;
  padding: 0;
}
form input {
  height: 54px;
  width: 100%;
  border: 1px solid #c4c4c4;
  border-radius: 5px;
  -webkit-box-shadow: 0px 5px 8px 0px rgba(163, 155, 163, 1);
  -moz-box-shadow: 0px 5px 8px 0px rgba(163, 155, 163, 1);
  box-shadow: 0px 5px 8px 0px rgba(163, 155, 163, 1);
}
form p {
  margin: 5px 0 0 5px;
  font-size: 16px;
  font-weight: 400;
  font-family: "Poppins", sans-serif;
  color: #090741;
}
h1 {
  font-size: 48px;
  font-weight: 200;
  text-align: left;
  margin-bottom: 2rem;
  font-family: "Poppins", sans-serif;
}
.loginButton {
  color: white;
  width: 100%;
  font-size: 16px;
  background: rgb(251, 137, 40);
  background: -moz-linear-gradient(
    85deg,
    rgba(251, 137, 40, 1) 19%,
    rgba(229, 5, 130, 1) 100%
  );
  background: -webkit-linear-gradient(
    85deg,
    rgba(251, 137, 40, 1) 19%,
    rgba(229, 5, 130, 1) 100%
  );
  background: linear-gradient(
    85deg,
    rgba(251, 137, 40, 1) 19%,
    rgba(229, 5, 130, 1) 100%
  );
  border: 0;
  border-radius: 9px;
  min-height: 62px;

  margin: 0px;
  margin-top: 20px;
}
.alert {
  margin-top: 20px;
  min-height: 40px;
  width: 100%;
  color: rgb(216, 8, 8);
  font-weight: bold;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media only screen and (max-width: 750px) {
  .container {
    flex-direction: column;
  }
  .leftContainer {
    width: 100%;
    height: 30vh;
    background: none !important;
  }
  .rightContainer form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 300px;
    font-family: "Poppins", sans-serif;
    padding: 0;
    margin: 0;
  }
  .loginButton {
    margin: 0;
    margin-top: 30px;
  }

  .rightContainer {
    width: 100%;
  }
}
</style>
